import PhotoGridViewerActionButton from './PhotoGridViewerActionButton';

export default PhotoGridViewerActionButton;
